export enum EPccCommentType {
  FIRST_REVIEWER = "FIRST_REVIEWER",
  SECOND_REVIEWER = "SECOND_REVIEWER",
  APPROVER = "APPROVER",
  EMPLOYER = "EMPLOYER",
}
